import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "dType", "dName", "dTeam", "dDate", "dContent", "dRemark", "projectsModal", "projectsContainer"]

  connect() {
    this.currentButton = null;
  }

  openRequest(event) {
    const { reqType, name, team, date, content, remark } = event.currentTarget.dataset;

    this.dTypeTarget.textContent = reqType === 'leave' ? '休暇申請' : '勤怠承認申請';
    this.dNameTarget.textContent = name;
    this.dTeamTarget.textContent = team;
    this.dDateTarget.textContent = date;
    this.dContentTarget.textContent = content;
    this.dRemarkTarget.textContent = remark;

    this.currentButton = event.currentTarget;
    this.modalTarget.classList.add('show');
  }

  closeRequest() {
    this.modalTarget.classList.remove('show');
  }

  openModal(event) {
    const projectsData = event.currentTarget.dataset.projects;
    if (!projectsData) return;

    const projects = JSON.parse(projectsData);

    let html = '';
    projects.forEach(project => {
      html += `
        <div class="card p-3" style="border: 1px solid var(--border-color, #eee); border-radius: 4px; text-align: left;">
          <div style="font-weight: bold; margin-bottom: 4px;">${project.name}</div>
          <div style="font-size: 0.9em; color: #444; line-height: 1.4;">${project.details}</div>
        </div>
      `;
    });

    if (projects.length === 0) {
      html = '<div class="text-center w-100">作業内容がありません</div>';
    }

    this.projectsContainerTarget.innerHTML = html;
    this.projectsModalTarget.classList.add('show');
  }

  closeModal() {
    this.projectsModalTarget.classList.remove('show');
    this.projectsContainerTarget.innerHTML = '';
  }

  approveRequest() {
    if (!this.currentButton) return;

    const row = this.currentButton.closest('tr');
    if (row && row.cells.length > 6) {
      row.cells[6].textContent = '承認済';
    }

    this.currentButton.textContent = '承認済';
    this.currentButton.disabled = true;
    this.currentButton.style.opacity = '0.6';
    this.currentButton.style.cursor = 'default';

    this.closeRequest();
  }
}
